export default {
  'options': {
    'units': {
      'kilometers': 'kilomètres',
      'meters': 'mètres',
      'miles': 'milles',
    },
    'areUnits': {
      'sqKms': 'kilomètres carrés',
      'hectare': 'hectares',
      'sqMeters': 'mètres carrés'
    }
  }
}
